import { useTheme } from 'styled-components';
import { T as ThemeModePreference, a as ThemeMode } from './ThemeMode-DBlsP3Iq.js';

/**
 * Hook that returns the current theme mode from the theme context.
 * @returns The current theme mode (light, dark, or system).
 */
var useThemeMode = () => {
  var _ref;
  const {
    themeMode,
    themeModePreference
  } = (_ref = useTheme()) !== null && _ref !== void 0 ? _ref : {
    themeMode: ThemeMode.LIGHT,
    themeModePreference: ThemeModePreference.LIGHT
  };
  return {
    themeMode,
    themeModePreference
  };
};

export { useThemeMode as u };
//# sourceMappingURL=useThemeMode-LB4rbIZS.js.map
